module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_j_leucistic.1f2cf9b4.png";